import { ajax } from './ajax'

// 学校概览
export const reqSchoolOverview = (paramets) => ajax(`/analysic/jxAnalysic/getSchoolProspectus`,paramets);

// 课件资源占比
export const reqCourseware = (paramets) => ajax(`/analysic/jxAnalysic/getResourceProportion`,paramets);

//  活动参与率
export const reqActivityProportion = (paramets) => ajax(`/analysic/jxAnalysic/getActivityProportion`,paramets);

//  周到课率
export const reqAttendance = (paramets) => ajax(`/analysic/jxAnalysic/getAttendance`,paramets);

//  成绩分析
export const reqAchievementAnalysis = (paramets) => ajax(`/analysic/jxAnalysic/getAchievementAnalysis`,paramets);

// 系部资源
export const reqDepartmentResource = (paramets) => ajax(`/analysic/jxAnalysic/getSdeptProportion`,paramets);

// 系部资源查询对应key
export const reqSdeptProportionDetails = (paramets) => ajax(`/analysic/jxAnalysic/getSdeptProportionDetails`,paramets);


// WEBPACK FOOTER //
// ./src/api/situation.js